import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useBreadcrumbsStore } from "../hooks/breadcrumbStore";

// Breadcrumb visibile per le pagine interne. Niente trail in home (meno di 2 voci).
export default function Breadcrumbs() {
  const items = useBreadcrumbsStore();
  const { pathname } = useLocation();
  if (!items || items.length < 2) return null;
  // Evita breadcrumb "stale" se la pagina corrente non ha aggiornato lo store.
  const lastPath = (items[items.length - 1].path || "").replace(/\/$/, "");
  if (lastPath && lastPath !== pathname.replace(/\/$/, "")) return null;
  return (
    <nav
      aria-label="breadcrumb"
      data-testid="breadcrumbs"
      className="font-figtree"
      style={{ background: "#FFFFFF", borderBottom: "1px solid #ECEEF1" }}
    >
      <ol
        className="mx-auto max-w-[1280px] px-4 md:px-8 py-2.5 flex items-center flex-wrap gap-1.5 text-[13px]"
        style={{ color: "#6B7280", listStyle: "none", margin: 0, padding: "10px 16px" }}
      >
        {items.map((b, i) => {
          const last = i === items.length - 1;
          return (
            <li key={b.path || b.name} className="flex items-center gap-1.5 min-w-0" style={{ maxWidth: "100%" }}>
              {i > 0 && <ChevronRight size={14} aria-hidden="true" style={{ color: "#B6BCC6", flex: "none" }} />}
              {last ? (
                <span aria-current="page" className="font-semibold truncate" style={{ color: "#111318" }} data-testid="breadcrumb-current">
                  {b.name}
                </span>
              ) : (
                <Link to={b.path || "/"} className="truncate hover:underline" style={{ color: "#6B7280" }} data-testid={`breadcrumb-link-${i}`}>
                  {b.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
